import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SchoolIcon from "@mui/icons-material/School";
import StarIcon from "@mui/icons-material/Star";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./GrabCertificateHelpSection.css";

const GrabCertificateHelpSection = () => {
  const cards = [
    {
      icon: <SchoolIcon style={{ fontSize: 50, color: "#a855f7" }} />,
      title: "Boost Career",
      subtitle: "Our certificates validate your skills in the job market.",
    },
    {
      icon: <StarIcon style={{ fontSize: 50, color: "#a855f7" }} />,
      title: "Stand Out",
      subtitle: "Showcase expertise with industry-recognized achievements.",
    },
    {
      icon: <WorkspacePremiumIcon style={{ fontSize: 50, color: "#a855f7" }} />,
      title: "Global Recognition",
      subtitle: "Get certificates trusted by recruiters worldwide.",
    },
  ];

  const sectionOneDetails = [
    {
      logo: "https://via.placeholder.com/50",
      title: "Add To Your Resume",
      subtitle: "Highlight your certifications to improve job opportunities.",
    },
    {
      logo: "https://via.placeholder.com/50",
      title: "Post on Linkedin",
      subtitle: "Share your achievement with your professional network.",
    },
    {
      logo: "https://via.placeholder.com/50",
      title: "Add to Linkedin Profile",
      subtitle: "Attach certifications directly to your LinkedIn profile.",
    },
    {
      logo: "https://via.placeholder.com/50",
      title: "Share At Interviews",
      subtitle: "Showcase your certified expertise confidently.",
    },
  ];

  return (
    <div className="grabcertificateHelpSection-container">
      <h2 className="grabcertificateHelpSection-title">
        How our Certificates Help
      </h2>

      {/* Cards */}
      <div className="grabcertificateHelpSection-cards">
        {cards.map((card, i) => (
          <div key={i} className="grabcertificateHelpSection-card">
            <div className="grabcertificateHelpSection-cardIcon">
              {card.icon}
            </div>
            <h3 className="grabcertificateHelpSection-cardTitle">
              {card.title}
            </h3>
            <p className="grabcertificateHelpSection-cardSubtitle">
              {card.subtitle}
            </p>
          </div>
        ))}
      </div>

      {/* Accordions */}
      <div className="grabcertificateHelpSection-accordion">
        {/* Accordion 1 */}
        <Accordion sx={{ backgroundColor: "#fff" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h4 className="grabcertificateHelpSection-accordionTitle">
              Get Hired <span className="gradient-text">47%</span> Faster
            </h4>
          </AccordionSummary>
          <AccordionDetails>
            <div className="grabcertificateHelpSection-accordionCardColumn">
              {sectionOneDetails.map((item, idx) => (
                <div key={idx} className="grabcertificateHelpSection-rowItem">
                  <img
                    src={item.logo}
                    alt="logo"
                    className="grabcertificateHelpSection-rowLogo"
                  />
                  <div className="grabcertificateHelpSection-rowContent">
                    <h3>{item.title}</h3>
                    <p>{item.subtitle}</p>
                  </div>
                </div>
              ))}
            </div>
          </AccordionDetails>
        </Accordion>

        {/* Accordion 2 */}
        <Accordion sx={{ backgroundColor: "#fff" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h4 className="grabcertificateHelpSection-accordionTitle">
              Be Different from <span className="gradient-text">1 Lakh</span>{" "}
              College Students
            </h4>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {[
                "Use your certificate to earn college credits",
                "Use it as part of applications to foreign universities, master’s, and internships.",
                "Use it in your scholarship or grant application to show advanced skills.",
                "Share it to showcase your dedication to expanding your skills.",
              ].map((text, i) => (
                <ListItem key={i}>
                  <ListItemIcon>
                    <CheckCircleIcon style={{ color: "#a855f7" }} />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>

        {/* Accordion 3 */}
        <Accordion sx={{ backgroundColor: "#fff" }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <h4 className="grabcertificateHelpSection-accordionTitle">
              Boost Your Credibility By{" "}
              <span className="gradient-text">39%</span>
            </h4>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {[
                "Anyone can verify your certificate instantly.",
                "Co-Certified by Top Brands.",
              ].map((text, i) => (
                <ListItem key={i}>
                  <ListItemIcon>
                    <CheckCircleIcon style={{ color: "#a855f7" }} />
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default GrabCertificateHelpSection;
